import { useLoginWithOAuth } from '@privy-io/react-auth';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import { useDisconnectWallets } from 'src/hooks/wallets/useDisconnectWallets';
import { notify } from 'src/utils/notifications';

export default function usePrivyGoogleOAuth() {
	const connected = useWalletIsConnected();
	const disconnectWallets = useDisconnectWallets();
	const { initOAuth, state: loginWithOAuthState } = useLoginWithOAuth();

	const isGoogleOAuthLoginInProgress = loginWithOAuthState.status === 'loading';

	const loginWithGoogleOAuth = async () => {
		try {
			if (connected) {
				await disconnectWallets();
			}

			await initOAuth({ provider: 'google' });
		} catch (error) {
			console.error(error);

			notify({
				type: 'error',
				message: 'Failed to start Privy Google login.',
			});
		}
	};

	return {
		loginWithGoogleOAuth,
		isGoogleOAuthLoginInProgress,
	};
}
